export class Video
{
	buttons = document.querySelectorAll('[data-s~="Video:show"]')
	video = document.querySelector('[data-s~="Video:video"]')
    src

    constructor(store)
    {
        this.store = store
    }

    play()
	{
        this.video.src = this.src+"?autoplay=1"
	}

    stop()
	{
        this.video.src = this.src
	}

	watch()
	{
        this.buttons.forEach(e => {
            e.addEventListener("click", () => {
                this.src = e.getAttribute("data-video")
				this.play()
			})
		})
        addEventListener("modal", (e) => {
            if (
                e.detail.action == "hide" &&
                e.detail.target == "video"
            ) {
                this.stop()
            }
        })
	}
}
